import React from 'react';
import { Link } from 'react-router-dom';
import { companyInfo } from '../data/mock';

const About = () => {
  return (
    <div className="min-h-screen">
  
{/* Hero Banner */}
<section 
  data-testid="about-hero"
  className="relative h-[400px] overflow-hidden"
>
  <img 
    src="/images/about/about.jpg" 
    alt="About Everkast NZ" 
    className="absolute inset-0 w-full h-full object-cover"
  />

  <div className="absolute inset-0 bg-gradient-to-br from-black/70 via-blue-900/40 to-black/80"></div>

  <div className="absolute inset-0 flex items-center justify-center">
    <h1 className="text-white text-4xl md:text-5xl font-bold whitespace-nowrap">
      About Everkast NZ
    </h1>
  </div>
</section>

      {/* SECTION 1 */}
      <section className="bg-white">
        <div className="max-w-7xl mx-auto px-6 py-20 grid lg:grid-cols-2 gap-16 items-center">

          <div>
            <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-6">
              About Everkast NZ
            </h2>

            <p className="text-slate-600 text-lg leading-relaxed mb-6">
              {companyInfo.about.intro}
            </p>

            <p className="text-slate-600 text-lg leading-relaxed mb-8">
              {companyInfo.about.range}
            </p>

            <Link
              to="/request-quote"
              className="inline-block px-8 py-3 bg-green-600 text-white rounded-lg font-medium hover:bg-green-700 transition-all duration-200"
            >
              Get a Quote Today
            </Link>
          </div>

          <div>
            <img
              src="/images/about/about-1.webp"
              alt="About Everkast"
              className="w-full h-[420px] object-cover rounded-xl shadow-md"
              onError={(e) => e.target.src = "/images/fallback.png"}
            />
          </div>

        </div>
      </section>

      {/* SECTION 2 */}
      <section className="bg-slate-50">
        <div className="max-w-7xl mx-auto px-6 py-20 grid lg:grid-cols-2 gap-16 items-center">

          <div className="order-last lg:order-first">
            <img
              src="/images/about/about-2.png"
              alt="Our Mission"
              className="w-full h-[420px] object-cover rounded-xl shadow-md"
              onError={(e) => e.target.src = "/images/fallback.png"}
            />
          </div>

          <div>
            <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-6">
              Our Mission
            </h2>

            <p className="text-slate-600 text-lg leading-relaxed mb-6">
              {companyInfo.about.mission}
            </p>

            <p className="text-slate-600 text-lg leading-relaxed mb-8">
              {companyInfo.about.quality}
            </p>

            
          </div>

        </div>
      </section>

      {/* CTA */}
      <section className="bg-slate-900 py-20 text-center">
        <div className="max-w-3xl mx-auto px-6">

          <h2 className="text-3xl md:text-4xl font-bold text-white mb-6">
            Get in Touch With Us Today
          </h2>

          <p className="text-slate-300 text-lg mb-8">
            {companyInfo.about.closing}
          </p>

          <Link
            to="/contact"
            className="inline-block px-10 py-4 bg-green-600 text-white rounded-lg font-semibold hover:bg-green-700 transition-all duration-200"
          >
            Enquire Now
          </Link>

        </div>
      </section>

    </div>
  );
};

export default About;